export default {
  state: {
    users: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        username: 1
      }
    }
  },
  getters: {
    getAllUsers: state => state.users,
    getUsersPage: state => state.users.page,
    getUserSearch: state => state.users.search
  },
  mutations: {
    fillUsers (state, data) {
      state.users.data = data
      state.users
    },
    clearUsers (state) {
      state.users.data = []
    },
    setUsersPage (state, page) {
      state.users.page = page
    },
    setUsersSort (state, sort) {
      state.users.sort = sort
    },
    setUserSearch (state, search) {
      state.users.search = search
    }
  },
  actions: {
    fetchUsers ({commit, rootState, state}) {
      commit('setFetching', true)
      let query = {
        $skip: (state.users.page - 1) * 10,
        $sort: state.users.sort
      }
      if (state.users.search.length) {
        query['orRegex'] = [
          {
            username: {
              $search: state.users.search
            }
          },
          {
            email: {
              $search: state.users.search
            }
          }
        ]
      }
      rootState.services.users.find({query}).then(result => {
        commit('fillUsers', result)
        commit('setFetching', false)
      })
    },
    saveUser ({dispatch, commit, state, rootState}, data) {
      rootState.services.users.create(data)
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            message: 'Operatiune reusita. Utilizator adaugat.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    updateUser ({dispatch, commit, state, rootState}, data) {
      rootState.services.users.patch(data._id, data)
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            message: 'Operatiune reusita. Utilizator modificat.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    toggleSuperadmin ({dispatch, commit, state, rootState}, data) {
      rootState.services.users.patch(data._id, {superadmin: data.superadmin})
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            message: `Operatiune reusita. Utilizatorul ${res.username} a fost ${res.superadmin ? 'promovat' : 'retrogradat'}.`,
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    deleteUser ({dispatch, commit, state, rootState}, _ids) {
      rootState.services.users.remove(null, {query: {_id: {$in: _ids}}})
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            message: `Operatiune reusita. ${res.length} utilizator(i) eliminat(i).`,
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    setEventWatchers ({dispatch, commit, rootState}) {
      rootState.services.users.on('created', user => {
        dispatch('fetchUsers')
      })
      rootState.services.users.on('updated', user => {
        dispatch('fetchUsers')
      })
      rootState.services.users.on('patched', user => {
        dispatch('fetchUsers')
      })
      rootState.services.users.on('removed', user => {
        dispatch('fetchUsers')
      })
    },
    checkEmail ({rootState}, email) {
      return rootState.services.users.find({query: {email: email}})
    },
    setUsersPage ({commit, dispatch}, page) {
      commit('setUsersPage', page)
      dispatch('fetchUsers')
    },
    setUsersSort ({commit, dispatch}, sort) {
      commit('setUsersSort', sort)
      dispatch('fetchUsers')
    },
    setUserSearch ({commit, dispatch}, search) {
      commit('setUserSearch', search)
      dispatch('fetchUsers')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/users.js